// extracted by mini-css-extract-plugin
export default {"header":"Header_header__d+igc","title":"Header_title__Md3AU"};